import EditBillingUser from "./EditBillingUser";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function EditBillingUserWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <EditBillingUser />
        </XeroFeatureFlagCheck>
    )
}

export default EditBillingUserWrapper;